<template>
<panel>
    <p slot="header">
        {{ item.name }} <span class="gray">(konto do wysyłania)</span>
    </p>
    <p slot="actions">
        <ui-button type="flat" icon="navigate_before" color="primary" @click="$router.push({name: 'admin.accounts.show', params:{id: item.id}})">Wróć</ui-button>
        <ui-button type="flat" icon="mode_edit" color="primary" @click="edit">Edytuj konto</ui-button>
    </p>

    <accounts-test-form :item="item" v-if="item"></accounts-test-form>
</panel>

</template>
<script>
import Accounts from './../../services/Accounts'
import Loading from './../../mixins/Loading'
import Notify from './../../mixins/Notify'

export default {
  mixins: [Loading, Notify],
  data () {
    return {
      showPassword: false,
      item: Accounts.getBaseItem(),
      id: null
    }
  },
  mounted () {
    this.id = this.$route.params.id
    this.getItem(this.id)
  },
  methods: {
    edit () {
      this.$router.push({name: 'admin.accounts.edit', params: {id: this.id}})
    },
    test () {
      this.$router.push({name: 'admin.accounts.test', params: {id: this.id}})
    },
    getItem (id) {
      this.setLoading(true)
      Accounts.get(id).then((res) => {
        this.item = res.data.item
        this.setLoading(false)
      })
    }
  }
}

</script>


// WEBPACK FOOTER //
// Test.vue?d6b762d8